import React, { Fragment, useState } from "react";
import { Popover, IconButton, Box, Tooltip } from "@material-ui/core";
import MoreVertOutlinedIcon from "@material-ui/icons/MoreVertOutlined";
import useStyles from "./styles";
import { get, isEmpty } from "lodash";
import ButtonPopover from "./ButtonPopover";
import ButtonLoader from "./ButtonLoader";

const GenericActionPopover = ({ menuList, ...props }) => {
  const classes = useStyles();
  // popover trigger
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);

    if (
      props.tagetListFrom === "dashboardTarget" ||
      props.tagetListFrom === "targets"
    ) {
      props.updateOrangeDotHighlightStatus(props.colProps);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
    if (
      props.tagetListFrom === "dashboardTarget" ||
      props.tagetListFrom === "targets"
    ) {
      props.updateOrangeDotHighlightStatus(props.colProps);
    }
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  // const divider = type => {
  //   return type === "delete" ? <span className={classes.divider}></span> : null;
  // };
  const getMenuList = () => {
    return menuList.map((res) => {
      const buttonValue = res.isLink ? (
        <ButtonPopover label={res.label} link={res.link} isLink={res.isLink} />
      ) : (
        <ButtonPopover
          data-testid="handleClose"
          onClick={() => {
            res.onClick();
            handleClose();
          }}
          label={res.label}
        />
      );

      let totalCount =
        res?.targetMessageCount +
        res?.targetAttachmentsCount +
        res?.objectivesCount;

      return (
        <Fragment>
          {/* {divider(get(res, "type", ""))} */}
          <li>
            {get(res, "isLoader", false) ? (
              <ButtonLoader isLoader={get(res, "isLoader", false)} />
            ) : (
              res?.userType !== "coachee" && (
                <Box position="relative">
                  {res?.isNewAction &&
                    (res?.reviewProgressPending > 0 ||
                      res?.orangeDotCount > 0) && (
                      <span className={classes.kebabMenuCount}>
                        {!res?.completionApprovalRequired ||
                          res?.userType === "coach" ||
                          res?.userType === "leadReviewer"
                          ? res?.orangeDotCount
                          : res?.reviewProgressPending}
                      </span>
                    )}
                  {res?.targetMessageCount > 0 ||
                    res?.targetAttachmentsCount > 0 ||
                    res?.objectivesCount > 0 ? (
                    <span className={classes.kebabMenuCount}>
                      {totalCount !== "NaN" ? totalCount : 0}
                    </span>
                  ) : null}
                  {buttonValue}
                </Box>
              )
            )}
          </li>
        </Fragment>
      );
    });
  };

  return (
    <Fragment>
      <Box {...props} className="action-popover">
        {!isEmpty(menuList) && (!props.loggedInUserRole || props.viewingOwnProfile) ? (
          <Tooltip title="Click to open">
            <IconButton
              data-testid="iconbtn"
              aria-label="click to open"
              aria-describedby={id}
              onClick={handleClick}
              className={classes.kebabMenu}
              size="small"
            >
              <MoreVertOutlinedIcon fontSize="small" />
              {menuList?.map((item) => {
                if (
                  item?.isNewAction ||
                  item?.targetMessageCount > 0 ||
                  item?.targetAttachmentsCount > 0 ||
                  item?.objectivesCount > 0
                ) {
                  return <span className={classes.kebabNotif}>&nbsp;</span>;
                }
              })}
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Click to open">
            <IconButton
              disabled
              data-testid="iconbtn"
              aria-label="click to open"
              aria-describedby={id}
              size="small"
              className="ml5"
            >
              <MoreVertOutlinedIcon
                fontSize="small"
                className={classes.disableKebab}
              />
            </IconButton>
          </Tooltip>
        )}

        <Popover
          className={classes.actionPopover}
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <ul
            className={`${classes.actionPopoverList} ${(props?.tagetListFrom === "targets",
              "dashboardTarget" ? "target-list-menu" : "")
              }`}
          >
            {getMenuList()}
          </ul>
        </Popover>
      </Box>
    </Fragment>
  );
};

export default GenericActionPopover;
